import { useCallback } from 'react';
import { useAuth } from '../auth/AuthContext';
import {
  canBookAssets,
  canMutateAssets,
  isBusinessClientLogin,
} from '../auth/userLoginType';
import { useBookingCreate } from '../booking/BookingCreateContext';
import { useProfileBookingGate } from '../booking/ProfileBookingGateContext';
import { useI18n } from '../i18n';
import { useAppNavigation } from '../navigation/AppNavigationContext';
import { assetRecordMutationId } from '../utils/assetRecordPrimaryId';

/** Book action + gating for consumer asset lists (browse tab, header search). */
export function useActiveAssetListBook() {
  const { t } = useI18n();
  const { isLoggedIn, userLoginType } = useAuth();
  const { openBookings } = useAppNavigation();
  const { requestAssetQuickBook } = useBookingCreate();
  const { guardBookingAction } = useProfileBookingGate();

  const showBook = !canMutateAssets(userLoginType);
  const bookDisabled = !canBookAssets(userLoginType);
  const bookDisabledReason = !isLoggedIn
    ? t('assets.bookSignIn')
    : !canBookAssets(userLoginType)
      ? isBusinessClientLogin(userLoginType)
        ? t('bookings.error.roleBlock.businessClient')
        : t('bookings.error.roleBlock.loginType')
      : undefined;

  const onBook = useCallback(
    (asset: Record<string, unknown>) => {
      const id = assetRecordMutationId(asset);
      if (!id) {
        return;
      }
      guardBookingAction(() => {
        requestAssetQuickBook(id, asset);
        openBookings({ preserveCreateFlow: true });
      });
    },
    [guardBookingAction, openBookings, requestAssetQuickBook],
  );

  return { showBook, onBook, bookDisabled, bookDisabledReason };
}
